import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import React from "react";


import {DataSource} from "../../../../../stores/dataSources/DataSource";


import {Select} from "../../../../components/form/Select/Select";


export interface QuizResultFilterProps {
    dataSource: DataSource
    className?: string;
}

export const QUIZ_RESULT_FILTER_VALUES = {
    FAILED: 'failed',
    PASSED: 'passed',
    NOT_STARTED: 'not_started',
}

const getResultOptions = () => [
    {
        value: "failed",
        label: <div className="Quizzes_td--failed">{intl.get('tests.statusFilter.failed').d("Failed")}</div>,
    },
    {
        value: "passed",
        label: <div className="Quizzes_td--passed">{intl.get('tests.statusFilter.passed').d("Passed")}</div>,
    },
    {
        value: 'not_started',
        label: <div
            className="Quizzes_td--notStarted">{intl.get('tests.statusFilter.notStarted').d("Not started")}</div>,
    }
];

export const QuizResultFilter = observer(
    (
        {
            dataSource,
            className
        }: QuizResultFilterProps
    ) => {
        return (
            <Select
                className={className}
                shouldForcePlace={true}
                selectedValue={dataSource.filterValues.status}
                options={getResultOptions()}
                onChange={(newValue) => dataSource.setFilterValue('status', newValue)}
                placeholder={intl.get('tests.statusFilter.placeholder').d("All Results")}
                selectBoxMinWidth={146}
                size={"medium"}
                allowEmpty={true}
            />
        )
    })
